const ContainerLoading = () => {
  return (
    <div className="w-full h-full flex items-center justify-center bg-gray rounded-[15px] bg-opacity-60">
      <div className="w-8 h-8 border-4 border border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default ContainerLoading;
